<script>
    import axios from "axios";
    import Vue from "vue";

    export default {
        name: "SafePassphrasePicker",
        props: {
            name: String,
        },
        data() {
            return {
                passPhrase: "",
                passChecks: {},
                dictionaryWords: {},
                loadingDictionary: true,
                showingMoreInfo: false,
                explainWhyWords: false,
            };
        },

        methods: {
            passChosen() {
                this.$emit("on-chosen", this.passPhrase);
            },
            checkPass() {
                let res = {
                    length: false,
                    usesWords: false,
                    nonDictWords: false,
                    ok: false,
                };

                let passPhrase = this.passPhrase || "";
                let words = passPhrase.split(/\W/g).filter(w => w.length > 0);

                res.usesWords = words.length > 1;
                res.length = passPhrase.length >= 20;

                let threeOrMoreLetters = words.filter(word => word.length >= 3);
                res.nonDictWords =
                    words.length > 1 &&
                    threeOrMoreLetters.length > 1 &&
                    this.foundInDict(words).length < threeOrMoreLetters.length;

                res.ok = res.length && res.usesWords && res.nonDictWords;
                this.passChecks = res;
            },

            foundInDict(words) {
                // returns all words that can be found in our dictionary
                // the dictionary consists of top 10k english words. other dicts are sort of out of scope
                let found = [];
                words.forEach(word => {
                    let prefix = word.substr(0, 4);
                    let suffixes = this.dictionaryWords[prefix] ? this.dictionaryWords[prefix].split(/,/g) : [];
                    let dictWords = suffixes.map(suffix => prefix + suffix.replace("$", ""));

                    if (dictWords.includes(word)) {
                        found.push(word);
                    }
                });
                return found;
            },
        },

        mounted() {
            axios.get("/words-4.json").then(response => {
                this.dictionaryWords = response.data;
                this.loadingDictionary = false;
            });
            this.$refs.passphrase.focus();
        },
    };
</script>

<template>
    <div class="safe-passphrase-picker">
        <form class="pass-check" @submit.prevent="passChosen()">
            <input
                v-model="passPhrase"
                type="input"
                placeholder="Passphrase is a qu'irky sentence"
                @keyup="checkPass"
                ref="passphrase"
            />

            <button class="btn accent" :disabled="!passChecks.ok">
                All good!
            </button>
        </form>

        <div class="requirements-box">
            <ul>
                <li :class="{passed: passChecks.usesWords}">
                    <button class="checkbox">
                        <Emoji name="check-mark" />
                    </button>

                    <p>
                        Uses words separated by spaces or any other non-letter symbol.
                    </p>
                </li>
                <li :class="{passed: passChecks.nonDictWords}">
                    <button class="checkbox">
                        <Emoji name="check-mark" />
                    </button>

                    <p>
                        At least one non-dictionary word longer than 3 characters
                    </p>
                </li>
                <li :class="{passed: passChecks.length}">
                    <button class="checkbox">
                        <Emoji name="check-mark" />
                    </button>
                    <p>
                        Total length at least 20 characters
                    </p>
                </li>
            </ul>
        </div>
    </div>
</template>


<style lang="scss">
    .safe-passphrase-picker {
        form {
            max-width: 600px;
            margin: 2em auto;
            display: grid;
            grid-template-columns: 1fr auto;
            gap: 20px;

            input {
                flex-grow: 1;
            }
        }

        .requirements-box {
            margin: 2em 3em;
            color: #666;

            li {
                display: grid;
                grid-template-columns: auto 1fr;
                align-items: center;

                .checkbox {
                    position: relative;
                    border: 2px solid #ccc;
                    border-radius: 3px;
                    height: 1em;
                    width: 1em;
                    margin: 10px;
                    margin-right: 1em;

                    .emoji {
                        position: absolute;
                        width: 50px;
                        height: 50px;
                        top: 0;
                        left: 0;
                        margin-top: -15px;
                        margin-left: -15px;
                        opacity: 1;
                        max-height: 35px;
                        display: none;
                    }
                }

                p {
                    margin: 0;
                }

                &.passed {
                    .checkbox .emoji {
                        display: block;
                    }

                    p {
                        color: #333;
                    }
                }
            }
        }

        ul {
            list-style: none;
            padding: 0;
            margin: 0;
            margin-top: 1em;

            li {
                display: flex;
                align-items: flex-start;
                margin-bottom: 1em;
            }
        }
    }


    @media (max-width: $mobile-break) {
        .safe-passphrase-picker {
            .requirements-box {
                margin-left: 0;
                margin-right: 1em;
            }



        }
    }
</style>



